export default {"src":"/_next/static/media/laptop-flawless.1bbfd66e.svg","height":67,"width":99};